// extracted by mini-css-extract-plugin
export default {"row":"basicDetails__row___4vQcr","fullWidth":"basicDetails__fullWidth___0lj5o","halfWidth":"basicDetails__halfWidth___mYSrw","thirdWidth":"basicDetails__thirdWidth___yWiDK"};